import styled, { css } from 'styled-components';
import {
    Col,
    Link,
} from '@zillow/zrs-comet';
import {
    Card,
    Text,
    Spacer,
} from '@zillow/constellation';

export const StyledCol = styled(Col)`
    box-sizing: border-box;
    height: 96px;
`;

export const StyledLink = styled(Link)`
    box-sizing: border-box;
    height: 96px;

    /* replaces SelectPropertyCard-Anchor.Link */
    color: inherit;
    text-decoration: inherit;
    cursor: pointer;

    &:hover {
        color: inherit;
        text-decoration: inherit;
    }
    ${props => props.theme.ns().spacing.getSpacingMixin()};
`;

export const StyledImg = styled.img`
    width: 100%;
    height: 100%;
`;

export const StyledSelectPropertyCardContent = styled(Spacer)`
    /* replaces .SelectPropertyCard-Content */
    flex-grow: 1;
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
`;

export const StyledSelectPropertyPageTitle = styled(Text)`
    ${props => props.theme &&
        props.theme.ns &&
        css`
            ${props.theme.ns().media.lg(css`
                text-align: center;
            `)}
        `
}
`;

export const StyledPropertyItemStatus = styled(Text)`
    /* replaces .Property-Item-Status */
    font-weight: 600;
`;

export const StyledPhotoContainer = styled.div`
    /* replaces .SelectPropertyCard-PhotoContainer */
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;

    width: 128px;
    height: 100%;

    border: 1px solid lightgray;
`;

export const StyledCard = styled(Card)`
    /* replaces .SelectPropertyCard */
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 100%;
    box-sizing: border-box;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
    background-color: #ffffff;
    border-radius: 3px;
`;

export const StyledListingStatus = styled(Spacer)`
    /* replaces .Property-Item-Status-Icon  */
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: gray;
      
    ${props => props.message === 'Listed for rent' && css`
        /* replaces .OnMarket */
        background-color: green;
    `}
`;

export const StyledStatusMessage = styled.div`
    /* .Property-Item-Status-Message */
    display: inline-block;
`;

export const StyledSpacer = styled(Spacer)`
    clear: both;
`;

export const StyledDivContainer = styled.div`
    ${props => props.theme &&
        props.theme.ns &&
        css`
            background-color: ${props.theme.ns().colors.backgroundGray};
        `
}
`;
